<template>
  <div class="natSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="4">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('alarms.common.pleaseSelectCompany')"
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="4">
        <!-- 账户类型 -->
        <Select
          v-model="accountType"
          filterable
          :placeholder="$t('alarms.common.filterByAccountType')"
          :transfer="true"
        >
          <Option value="" selected>{{ $t("alarms.common.all") }}</Option>
          <Option
            :value="item.id"
            v-for="item in accountTypeList"
            :key="item.name"
            >{{ item.name }}</Option
          >
        </Select>
      </Col>
      <Col span="4">
        <!--账户名称 -->
        <Input
          v-model="accountName"
          :placeholder="$t('alarms.common.filterByAccountName')"
        />
      </Col>
      <Col span="4">
        <!--弹性IP -->
        <Input
          v-model="natGatewayId"
          :placeholder="$t('alarms.common.filterByNatGatewayId')"
        />
      </Col>
      <Col span="4">
        <Button
          type="primary"
          v-hasPermission="['network:natMonitor:page']"
          @click="getData"
          >{{ $t("message.select") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import TableNat from "../nat/TableNat";
import { setCookie, getCookie } from "../../../../utils/cookieUtil";
import {
  CLOUD_PLATFORM_ID,
  buildPlatformOptions
} from "../../../../utils/cloudPlatform.js";
var tableNat = TableNat;
export default {
  name: "NatMonitorSearch",
  data() {
    return {
      natGatewayId: "",
      accountName: "",
      accountType: "",
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      accountTypeList: buildPlatformOptions([
        CLOUD_PLATFORM_ID.AWS,
        CLOUD_PLATFORM_ID.ALIYUN,
        CLOUD_PLATFORM_ID.AZURE,
        CLOUD_PLATFORM_ID.VMWARE,
        CLOUD_PLATFORM_ID.GCP
      ])
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    } else {
      tableNat.methods.showAll();
    }
  },
  methods: {
    getData() {
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("accountType", this.accountType);
      eventBus.$emit("accountName", this.accountName);
      eventBus.$emit("natGatewayId", this.natGatewayId);
      tableNat.methods.showAll();
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    }
  }
};
</script>
<style scoped>
.natSearch {
  height: 51px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/network/nat/NatMonitorSearch.vue